import { defaultCurrency } from '@/config/index'

const defaultCompanySettings = {
  currency: defaultCurrency,
}

export default defaultCompanySettings
